<template>
  <div>
    <el-menu class="navbar" mode="horizontal">
     <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
      <breadcrumb></breadcrumb>
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <!-- <img class="user-avatar" :src="avatar"> -->
          <span class="user-avatar" style="color: #409EFF;font-size: 20px;">{{userName}}</span>
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <router-link class="inlineBlock" to="/">
            <el-dropdown-item>
              首页
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item divided>
            <span style="display:block;" @click="logout">
              <!-- <a href="https://wtwf.yangzhizhe.com">退出</a> -->
			         退出
    		  </span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-menu>
  </div>

</template>
<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import { setToken,removeToken,getToken } from '@/utils/auth'
import Cookies from 'js-cookie'
import {getInfo} from '../../../api/login.js'
export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ])
  },
  data() {
    return {
		userName:''
	}
	},
  mounted(){
  	getInfo().then(res=>{
		console.log('获取名字',res.data.username)
		this.userName = res.data.username;
	}).catch(res=>{
	})
  },
  methods: {
    //退出
    clickOut(){
      // this.$router.push({path:'/login'})
    },
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
		console.log('退出',getToken('loginToken'));
    removeToken('loginToken');//移除token
    location.reload();//为了重新实例化vue-router对象 避免bug
      // this.$router.push({path:'/login'})
      // this.$store.dispatch('LogOut').then(() => {
        // this.$router.push('/login')
      //   location.reload() // 为了重新实例化vue-router对象 避免bug
      // })

    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 20px;
        font-size: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue